import React, { ReactElement } from "react";
import {HelpBox} from './HelpBox';

type RadarCommandsInputProps = {
    title: string;
    info: string;
    default?: string;
    setValue : Function;
    editValue : string;
    setEditValue : Function;
    clearValue? : Function;
    value: string;
    validate?: Function ; // Add this for custom validation
    invalidString?: string; // If the validate function is set, use this
    showModified? : boolean;
    isModified? : Function;
    readonly? : boolean;
    completions? : Array<string>;
}

export const RadarCommandsInput = (props : RadarCommandsInputProps)  : ReactElement  => {
    const selectDefault = () : string => {
        return props.default ? props.default : "";
    }
    const initialDefaultValue = selectDefault();
    const editValue = props.editValue;
    const setEditValue = props.setEditValue;
    const completions = props.completions ? props.completions : ['','sys:1', 'sys:0'];

    const [initialValue /*, setInitialValue */] = React.useState<string>(initialDefaultValue);
    const [isEditing, setIsEditing] = React.useState<boolean>(false);
    const isModified = ():boolean => {
        if (props.isModified) return props.isModified();
        return (props.showModified?true:false) && props.editValue !== initialValue;
    }

    const validate = (v : string):boolean => {
        return /^(((sys)|([0-9]+)):((,|[0-9]|\.)+);?)*$/g.test(v)
    }
    const valid:boolean = editValue === undefined || validate(editValue) || editValue==="" || props.readonly as boolean;
    const setValueLocal = (s : string) => {
        s = s.trim();
        setIsEditing(true);
        if (s === "" && props.clearValue)
            props.clearValue();
        else if (s === initialValue && props.clearValue)
            props.clearValue();
        else {
            if (validate(s))
                props.setValue(s);
            else if (props.clearValue) {
                console.log("clearing value");
                props.clearValue(); // Remove invalid settings
            }
        }
        setEditValue(s);
    }
    const displayValue:string = props.readonly ? props.value : (isEditing ? editValue : props.value);
    return <div className={isModified() ? "RadarInputBoxModified" : "RadarInputBox"}>
                <div className="Flexing2">
                <div className={isModified()?"NumericInputTitleModified":"NumericInputTitle"}>{props.title}<HelpBox name={props.title} info={props.info}/></div>
                </div>
                <input className="NumericInput" type="text" readOnly={props.readonly} list={"complete+"+props.title} value={displayValue} onChange={(e)=>setValueLocal(e.target.value)}/>
                <div className="Flexing">
                    <div className="NumericUnit">Radar Commands</div>
                    <div className={valid ? "NumericValidationGood" : "NumericInputValidationBad"}>{
                        valid ? (displayValue===""+props.default ? "DEFAULT" : (displayValue==="" ? "EMPTY" : "OK")) : "Bad format"}
                </div>
                </div>
                <datalist id={"complete+"+props.title}>
                {completions.map((k)=><option value={k}/>)};
                </datalist>
        </div>;
}

